/**
 * @description 路由拦截状态管理，目前两种模式：all模式与intelligence模式
 */
// import CEUtils from '@cekit/ce-utils';
import { getRouterList } from 'resfull/private/router';
import { getCustomMenuListByTenantId, getSystemMenuListByAppCode } from 'resfull/npgw/pcp';
import { formatMenuData, formatRouterData, filterPermissionsRoutes } from '@/router/lib/util';
import { dynamicRoutes } from '@/router/modules/dynamic';
import { clone } from 'utils/common_methods';
import settings from 'settings';
import { getRequest } from 'utils/tools';

// const views = import.meta.glob('../../views/**/*.vue');
const { rootComponent } = settings;

const state = () => ({
    routes: {}, // 路由数据
    menus: {}, // 菜单栏目数据
    menuRoutes: [], // 废除
    originalRoutes: [], // 废除 routes替代 后端返回未处理过的动态路由, `breadcrumb 面包屑中使用`，防止路由缓存时，menuData 变化，originalRoutesData也跟着变化。
    keepAliveNames: [],
    tagsViewRoutes: [],
    isVisual: false,
    showMenu: true,
});
const getters = {
    routes: state => state.routes,
    menus: state => state.menus,
    menuRoutes: state => (state.routes && state.routes.children) || [], // 废除 没有菜单则显示空数组，避免过滤器报错
    originalRoutes: state => state.originalRoutes, // 废除
    isVisual: state => state.isVisual,
    showMenu: state => state.showMenu,
};
const mutations = {
    setRoutes(state, routes) {
        state.routes = routes;
    },
    setMenus(state, menus) {
        state.menus = menus;
    },
    setOriginalRoutes(state, originalRoutes) {
        state.originalRoutes = originalRoutes; // 废除
    },
    // 设置路由缓存（name字段）
    getCacheKeepAlive(state, data) {
        state.keepAliveNames = data;
    },
    // 设置 TagsView 路由
    getTagsViewRoutes(state, data) {
        state.tagsViewRoutes = data;
    },
    setIsVisual(state, data) {
        state.isVisual = data;
    },
    setShowMenu(state, data) {
        state.showMenu = data;
    },
};
const actions = {
    async setPrivateRoutes({ commit }, permissions) {
        // 只过滤动态路由permissions，admin不再默认拥有全部权限
        let menus = [];
        // TODO WQ 这个私有化环境下的不懂什么意思
        /* IFTRUE_isMock */
        // 获得私有化数据表中的数据
        let { data } = await getRouterList();
        menus = data;
        /* FITRUE_isMock */
        /* IFTRUE_isProd */
        // 在发布模式中私有化没有启用则使用模拟数据
        menus = require('test_data/getPrivateMenuList.js').default;
        /* FITRUE_isProd */
        const { children } = menus[0];
        // 过滤权限，适用于私有化方式的过滤，不支持 permissions = 'all'
        const finallyAsyncRoutes = await filterPermissionsRoutes(children, permissions); // 权限分配
        // routes初始化, components组件初始化引入
        const menuRoutes = clone(menus[0]);
        menuRoutes.children = finallyAsyncRoutes;
        // commit提交
        commit('setMenus', menuRoutes); // 废除 记录原始的输入数据用于面包屑等
        commit('setRoutes', menuRoutes);
        return menuRoutes;
    },
    async setSaasRoutes({ commit }, { user, auth }) {
        console.log(location, getRequest().designSource);
        let results = null;
        if (getRequest().designSource == 'visual') {
            commit('setIsVisual', true);
            results = await getSystemMenuListByAppCode({ tenantId: user.tenantId, appCode: getRequest().applicationCode });
        } else if (getRequest().designSource == 'yx') {
            commit('setShowMenu', false);
            commit('setIsVisual', false);
            results = await getCustomMenuListByTenantId({ tenantId: user.tenantId });
        } else {
            commit('setIsVisual', false);
            results = await getCustomMenuListByTenantId({ tenantId: user.tenantId });
        }
        // 登录失效
        let routes = [];
        if (results.status === 999) {
            // 999分为没有和失效 没有直接跳转B端登录 失效应该给后端backUrl 实现免登 目前判定依据为是否存在
            return false;
        } else {
            const { data: menuList } = results;
            const menus = formatMenuData(menuList, auth);
            routes = formatRouterData(menuList, auth);
            commit('setMenus', menus);
            commit('setRoutes', routes);
            console.log('menus', menus)
        }
        return routes;
    },
    // 设置路由，菜单中使用到
    setVistorRoutes({ commit }, auths) {
        /* FITRUE_isMock */
        auths = 'all';
        /* FITRUE_isMock */
        let menus = [];
        if (typeof auths === 'string' && auths === 'all') {
            menus = dynamicRoutes;
        } else {
            menus = filterPermissionsRoutes(dynamicRoutes, auths);
        }
        let remenus = {
            path: '/',
            name: 'root',
            // component: views[`../../views/${rootComponent}.vue`],
            children: [
                {
                    path: '/home',
                    name: 'home',
                    // component: () => import('views/modules/home/index.vue'),
                    meta: {
                        title: '概览',
                        parent: '/home',
                        icon: 'el-icon-s-home',
                        path: '',
                        isApp: false,
                        isIframe: false,
                        isLink: false,
                        isAffix: true,
                        isHide: false,
                        params: {},
                    },
                },
                ...menus,
            ],
        };
        commit('setMenus', remenus); // 记录原始的输入数据用于记录面包屑
        commit('setRoutes', remenus);
        return remenus;
    },
    // keepAlive缓存
    async setCacheKeepAlive({ commit }, data) {
        commit('getCacheKeepAlive', data);
    },
    // 设置 TagsView 路由
    async setTagsViewRoutes({ commit }, data) {
        commit('getTagsViewRoutes', data);
    },
    // 清空路由
    clearRoutes({ commit }) {
        commit('getTagsViewRoutes', []);
        commit('setOriginalRoutes', []);
        commit('setRoutes', []);
    },
};
export default { state, getters, mutations, actions };
